module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterWithAlertIcon@3x-7d5361b5d14dd1c99f1c77bc4c99ba60.png";